import React from 'react';
import PropTypes from 'prop-types';

import AutoSuggestInput from '../core/AutoSuggestInput';
import registrationApi from '../../api/registrationApi';

const AddressAutoSuggest = ({ onSuggestionSelected, fieldValue, delay }) => {
  const [stateSuggestions, setSuggestions] = React.useState([]);
  const [stateIsFetching, setIsFetching] = React.useState(false);

  const getSuggestions = (searchKeyword) => {
    setIsFetching(true);
    registrationApi
      .searchAddress(searchKeyword)
      .then((response) => {
        if (!response.data) {
          setSuggestions([]);
          return;
        }

        const rawMatches = JSON.parse(response.data);
        if (rawMatches && rawMatches.status === 'SUCCESS') {
          const suggestions = rawMatches.payload;
          setSuggestions(suggestions);
        } else {
          setSuggestions([]);
        }
      })
      .finally(() => setIsFetching(false));
  };

  return (
    <AutoSuggestInput
      fieldValue={fieldValue}
      getSuggestions={getSuggestions}
      getSuggestionValue={(x) => x.fullAddress}
      onSuggestionSelected={onSuggestionSelected}
      suggestions={stateSuggestions}
      isGetSuggestionsDone={!stateIsFetching}
      suggestionsPlacement="bottom"
      delay={delay}
    />
  );
};

AddressAutoSuggest.propTypes = {
  onSuggestionSelected: PropTypes.func,
  fieldValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  delay: PropTypes.number,
};

AddressAutoSuggest.defaultProps = {
  onSuggestionSelected: null,
  fieldValue: null,
  delay: 800,
};

export default AddressAutoSuggest;
